// test627
(627 && 0);
